import React from 'react';
import HorusLogo from '../assets/LogoHorus.jpeg'; // Certifique-se de que o caminho do logo está correto
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWhatsapp, faFacebook, faInstagram } from '@fortawesome/free-brands-svg-icons';
import { useNavigate } from 'react-router-dom';

function Footer() {
  const navigate = useNavigate();

  const handleHomeClick = () => {
    navigate('/');
  };

  const handleInstagramClick = () => {
    window.open('https://www.instagram.com/clinica_horus_sarandi/', '_blank');
  };

  const handleWhatsappClick = () => {
    window.open('https://api.whatsapp.com/send?phone=5544991295607', '_blank');
  };

  const handleFacebookClick = () => {
    window.open('https://www.facebook.com/', '_blank');
  };

  return (
    <footer className="bg-blue-900 text-white py-8">
      <div className="container mx-auto px-6 flex flex-col md:flex-row items-center justify-between">
        {/* Logo à esquerda */}
        <div className="mb-6 md:mb-0">
          <img
            src={HorusLogo}
            alt="Logo da Clínica Hórus"
            className="h-16 cursor-pointer rounded-full"
            onClick={handleHomeClick}
          />
        </div>

        {/* Conteúdo de texto no meio */}
        <div className="text-center mb-6 md:mb-0">
          <p className="text-sm md:text-base">
            © 2024 Clínica Hórus - Todos os direitos reservados
          </p>
          <p className="text-xs md:text-sm text-blue-200 m-0 p-0">
            Sarandi-PR: Rua Pedro Galindo Garcia n555 Centro
          </p>
          <p className="text-xs md:text-sm text-blue-200 m-0 p-0">
            Marilva-PR: Rua Washington Luiz n1228  Centro -Marialva
          </p>
        </div>

        {/* Botões de redes sociais à direita */}
        <div className="flex space-x-4">
          <FontAwesomeIcon
            onClick={handleInstagramClick}
            icon={faInstagram}
            size="lg"
            className="text-white hover:text-blue-200 cursor-pointer transition"
          />
          <FontAwesomeIcon
            onClick={handleWhatsappClick}
            icon={faWhatsapp}
            size="lg"
            className="text-white hover:text-blue-200 cursor-pointer transition"
          />
          {/* 
          <FontAwesomeIcon
            onClick={handleFacebookClick}
            icon={faFacebook}
            size="lg"
            className="text-white hover:text-blue-200 cursor-pointer transition"
          />
          */}

        </div>
      </div>
    </footer>
  );
}

export default Footer;